export default __webpack_public_path__ + "static/media/570F24B0-C7F0-4A5F-AE42-B0DA7A41786C.e83b1e1f.jpg";